/** ログインしていない状態で画面を開いたら、ログイン画面へ戻す。 */
import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useSession } from '../auth/session-context.js';
import { LoadingBlock } from './StatusBlock.js';
import { Layout } from './Layout.js';
import { Button } from './ui/Button.js';
import { ResultBanner } from './ui/ResultBanner.js';

export function RequireSession(): ReactNode {
  const { status, notice, retryRestore } = useSession();
  if (status === 'loading') return <LoadingBlock label="ログインの状態を確認しています…" />;
  if (status === 'signed_out') return <Navigate to="/login" replace />;
  if (status === 'unreachable') {
    // 開き直した瞬間にサーバへつながらなかった。ログインは残してあるので、
    // つながったら「もう一度読み込む」でそのまま元の画面に戻れる（issue #363）
    return (
      <main className="admin-unreachable">
        <ResultBanner
          tone="error"
          message={notice ?? 'サーバにつながりませんでした。'}
          nextStep="ログインはそのままです。電話番号から入り直す必要はありません。"
          action={
            <Button variant="secondary" compact onClick={retryRestore}>
              もう一度読み込む
            </Button>
          }
        />
      </main>
    );
  }
  return <Layout />;
}
